import { Modal, Button } from "react-bootstrap";
import React, { Component } from "react";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

class DialogSso extends Component {
    state = {
        show: true,
    };

    handleSSO = () => {
      window.location.href="http://localhost:443";
      this.setState({ show: false });
      // window.location.href="https://api-spmi.kemdikbud.go.id";
      //window.location.href="http://103.56.190.112:8082";
    };
    handleShow = () => {
        this.setState({ show: true });
    }

    handleClose = () => {
        this.setState({ show: false });
    }
    render() {
        
        return (<>
          <Modal
            show={this.state.show}
            backdrop="static"
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            style={{marginTop: "10%"}}
          >
            <Modal.Body style={{padding: "40px 20px 20px 20px"}}>
              <center><img src={`${toAbsoluteUrl("/media/logos/info.png")}`} style={{marginBottom: "20px"}} /></center>
              <p style={{textAlign: "center", lineHeight: "20px"}}>
              <b style={{textTransform: "uppercase"}}>SPMI kini sudah bisa login menggunakan SSO DIKTI</b><br/>
              Disarankan untuk login menggunakan SSO agar informasi user anda tetap update-an yang terbaru.
              </p>
            </Modal.Body>
            <Modal.Body style={{borderTop: "0.5px solid #ccc"}}>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <Button variant="primary" style={{width: "100%"}} onClick={this.handleSSO}>
                        Sign In With SSO
                      </Button>
                    </div>
                    <div className="col-md-6">
                      <Button variant="secondary" style={{width: "100%"}} onClick={this.handleClose}>
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>)
    }
}
export default DialogSso;